import { memo, useCallback, useMemo } from 'react';
import RichEditor from '@components/common/RichEditor';

/**
 * 医评议案例编辑：无图片上传，纯文本粘贴优先。
 * 由外层 Form.Item 注入 value / onChange。请勿在同一组件上再传 onChange 覆盖表单（会导致无法写入），预览请用 onPreview。
 */
const TinymceEditor = memo(({ value, onChange, onPreview, initialValue, placeholder, id, showState }) => {
    const extraInit = useMemo(() => ({ paste_as_text: true }), []);

    const displayValue = value !== undefined && value !== null ? value : (initialValue ?? '');

    const handleChange = useCallback(
        html => {
            const v = html === '' || html == null ? '' : html;
            onChange?.(v);
            onPreview?.();
        },
        [onChange, onPreview],
    );

    if (!showState || !id) {
        return null;
    }

    return <RichEditor id={id} mode="standard" height={300} placeholder={placeholder} value={displayValue} onChange={handleChange} extraInit={extraInit} />;
});

export default TinymceEditor;
